export async function clearSensitiveCaches(): Promise<void> {
  if (typeof caches === 'undefined') return;
  const names = await caches.keys();
  await Promise.all(names.filter((name) =>
    /^osshelf-(?:v\d+|(?:static|dynamic)-v\d+)$/.test(name) && name !== 'osshelf-static-v3'
  ).map((name) => caches.delete(name)));
}
